import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FormContext } from '../context/FormContext';
import Header from './Header';

const SubtopicsScreen = () => {
  const [subtopics, setSubtopics] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { topic } = location.state;
  const { formData } = useContext(FormContext);

  const apiBaseUrl = "https://learningassistant.onrender.com/api/";

  useEffect(() => {
    fetch(`${apiBaseUrl}topics/topics?topic=${topic}`)
      .then(response => response.json())
      .then(data => setSubtopics(data.data))
      .catch(error => console.error('Error fetching subtopics:', error));
  }, [apiBaseUrl, topic]);

  const handleDone = () => {
    setLoading(true);
    fetch(`${apiBaseUrl}userTrack/userTracks`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({

        email: formData.email,
        topic,
        subtopics
      })
    })
      .then(response => response.json())
      .then(() => {setLoading(false); navigate('/success')})
      .catch(error => {setLoading(false); console.error('Error subscribing:', error)});
  };

  return (
    <div>
      <Header />
      <div className="center flex flex-col items-center h-screen">
        <div className="flex flex-col items-start justify-center w-full h-screen gap-6 max-w-xs md:max-w-sm">
        <h2 className='text-[#0D3C26] text-xl md:text-2xl'>Subtopics for {topic}</h2>
      
      {subtopics.length > 0 ?  (<ol className=' list-decimal text-[#0D3C26] text-sm md:text-base'>
          {subtopics.map((subtopic, index) => (
            <li key={index}>{subtopic}</li>
          ))}
        </ol>): <p className='text-[#0D3C26] text-sm md:text-base'>Please Wait...</p>}
        <button className={` button text-base md:text-xl max-w-48`} onClick={handleDone}>{loading && <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg> } {loading ? 'Please wait...' : 'Done'}</button>
      </div>
    </div>
    </div>
  );
};

export default SubtopicsScreen;
